import {
  Component,
  OnDestroy,
  OnInit,
  EventEmitter,
  Output,
  HostListener,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  faPhoneAlt,
  faFax,
  faEnvelope,
  faAddressCard,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import { debug, timeStamp } from "console";
import { Subscription } from "rxjs";
import { SharedFormService } from "src/app/shared-utility/services/shared-form.service";
import { SharedStateService } from "src/app/shared-utility/services/shared-state.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnDestroy {
  public screenWidth: any;
  phoneIcon: any = faPhoneAlt;
  faxIcon: any = faFax;
  faEmail: any = faEnvelope;
  faAddress: any = faAddressCard;
  faSignOut: any = faSignOutAlt;
  blnShowLogout = false;
  eventSub: Subscription;
  landingScreenLogo: boolean = true;
  allProductLogo: boolean = false;
  product1: boolean = false;
  product2: boolean = false;
  resetPassword: boolean = false;
  drawerOpen: boolean = false;
  blnHasCapital: boolean = false;
  blnHasLength: boolean = false;
  blnHasOneNumber: boolean = false;
  blnHasSpecialChar: boolean = false;
  blnLowerCase: boolean = false;
  localStoreKey: any;
  sideNavDashboard: boolean = true;
  sideNavMyProfile: boolean = false;
  sideNavMyPatient: boolean = false;
  sideNavAccountSetting: boolean = false;
  sideNavToolsAndForm: boolean = false;
  accountDetail: any;
  loggedInUser: any;
  adminPassword: any;
  adminConfirmPassword;
  facilityChange: boolean = false;
  logoCondition = "first";
  userCurrent;
  caseInProgress: boolean = false;
  isFacilityChanged: boolean = false;
  action: string;
  isRefresh: any;
  functionRefresh: any;
  @Output() showPopup = new EventEmitter<boolean>();
  @Output() showFacilityPopup = new EventEmitter<boolean>();
  @Output() showHideMobileBackground = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    private formSvc: SharedFormService,
    private sharedStateSvc: SharedStateService
  ) {
    this.sharedStateSvc.headerLogo.subscribe((logintest) => {
      this.logoCondition = logintest;
    });

    this.eventSub = this.formSvc.stateEvent.subscribe((hasState) => {
      this.blnShowLogout = hasState;
    });

    this.sharedStateSvc.loginUserInfo.subscribe((test) => {
      this.userCurrent = test;
    });

    this.eventSub = this.formSvc.isRefreshed.subscribe((evt) => {
      this.isRefresh = evt;
    }); this.eventSub = this.formSvc.functionRefresh.subscribe((evt) => {
      this.functionRefresh = evt;
    });

    this.eventSub = this.formSvc.caseInProgress.subscribe((evt) => {
      this.caseInProgress = evt;
    });

    this.eventSub = this.formSvc.facilityChange.subscribe((evt) => {
      this.isFacilityChanged = evt;
    });

    this.eventSub = this.formSvc.confirmExit.subscribe((evt) => {
      if (evt) {
        this.formSvc.caseInProgress.next(false);
        this.formSvc.facilityChangePopup.next(false);
        if (this.action == "logout") {
          this.logOut();
        } else if (this.action == "refresh") {
          this.procedeToLogin();
        } else if (this.action == "profile") {
          this.profile();
        }
        else if (this.action == "dashboard") {
          this.dashboard();
        }
      } else {
        this.action = "";
      }
    });
    this.formSvc.facilityChange.subscribe((evt) => {
      this.facilityChange = evt;
    });
  }
  setLocalStorage() {
    this.localStoreKey = window.localStorage.setItem("logoType", "login");
  }

  ngOnInit() {
    this.userCurrent = localStorage.getItem("username");
    this.eventSub = this.formSvc.stateEvent.subscribe(
      (hasState) => (this.blnShowLogout = hasState)
    );
    this.setLocalStorage();
    this.logoCondition = "first";
    this.setLogo();
    this.screenWidth = window.innerWidth;
    this.formSvc.dashboardRedirectConfirmEvent.subscribe((res)=>{
      this.checkProgress(res);
    })
  }

  checkProgress(action: string) {
    if (this.caseInProgress) {
      this.formSvc.displayPopup.next(true);
      this.action = action;
      this.showPopup.emit(true);
    } else if (this.isFacilityChanged) {
      this.formSvc.facilityChangePopup.next(true);
      this.action = action;
      this.showFacilityPopup.emit(true);
    } else if (action == "refresh") {
      this.procedeToLogin();
    } else if (action == "logout") {
      this.logOut();
    } else {
      switch (action) {
        case "profile":
          this.profile();
          break;

        case "dashboard":
          this.dashboard();
          break;

        case "myPatient":
          this.myPatient();
          break;

        case "toolsandforms":
          this.toolsandforms();
          break;

        case "accountSettings":
          this.accountSettings();
          break;

        case "logout":
          this.logOut();
          break;
      }
    }
  }
  dashboard(): void {
    this.action = "";
    const dashboard = document.getElementById("GoToDashboard");
    dashboard ? dashboard.click() : this.router.navigate(["/dashboard"]);

    this.sideNavDashboard = true;
    this.sideNavMyProfile = false;
    this.sideNavMyPatient = false;
    this.sideNavAccountSetting = false;
    this.sideNavToolsAndForm = false;
  }

  accountSettings(): void {
    this.action = "";
    if (this.router.url === '/dashboard') {
      document.getElementById("GoToAccountSettings").click();
    }
    else {
      this.router.navigate(["/dashboard"]);
      setTimeout(() => {
        document.getElementById("GoToAccountSettings").click();
      }, 700);
    }

    this.sideNavDashboard = false;
    this.sideNavMyProfile = false;
    this.sideNavMyPatient = false;
    this.sideNavAccountSetting = true;
    this.sideNavToolsAndForm = false;
  }

  myPatient(): void {
    this.action = "";
    if (this.router.url === '/dashboard') {
      document.getElementById("GoToMyPatients").click();
    }
    else {
      this.router.navigate(["/dashboard"]);
      setTimeout(() => {
        document.getElementById("GoToMyPatients").click();
      }, 700);
    }
    this.sideNavDashboard = false;
    this.sideNavMyProfile = false;
    this.sideNavMyPatient = true;
    this.sideNavAccountSetting = false;
    this.sideNavToolsAndForm = false;
  }

  profile(): void {
    this.action = "";
    this.router.navigate(["/profile"]);
    this.sideNavDashboard = false;
    this.sideNavMyProfile = true;
    this.sideNavMyPatient = false;
    this.sideNavAccountSetting = false;
    this.sideNavToolsAndForm = false;
  }
  toolsandforms(): void {
    this.action = "";
    if (this.router.url === '/dashboard') {
      document.getElementById("GoToToolsAndForms").click();
    }
    else {
      this.router.navigate(["/dashboard"]);
      setTimeout(() => {
        document.getElementById("GoToToolsAndForms").click();
      }, 700);
    }
    this.sideNavDashboard = false;
    this.sideNavMyProfile = false;
    this.sideNavMyPatient = false;
    this.sideNavAccountSetting = false;
    this.sideNavToolsAndForm = true;
  }
  logOut() {
    this.action = "";
    clearTimeout(this.isRefresh);
    clearTimeout(this.functionRefresh);
    this.formSvc.myPatientNavigationEvent.next('');
    this.router.navigate(["/logout"]);
    this.logoCondition = "first";

    this.sideNavDashboard = true;
    this.sideNavMyProfile = false;
    this.sideNavMyPatient = false;
    this.sideNavAccountSetting = false;
    this.sideNavToolsAndForm = false;
  }
  procedeToLogin(): void {
    this.action = "";
    this.formSvc.dashboardReloadEvent.next("dashboard");
  }

  setLogo() {
    if (this.logoCondition == "allProduct") {
      this.landingScreenLogo = false;
      this.allProductLogo = true;
      this.product1 = false;
      this.product2 = false;
    } else if (this.logoCondition == "product1") {
      this.landingScreenLogo = false;
      this.allProductLogo = false;
      this.product1 = true;
      this.product2 = false;
    } else if (this.logoCondition == "product2") {
      this.landingScreenLogo = false;
      this.allProductLogo = false;
      this.product1 = false;
      this.product2 = true;
    } else if (this.logoCondition == "first") {
      this.landingScreenLogo = true;
      this.allProductLogo = false;
      this.product1 = false;
      this.product2 = false;
    }
  }

  checkpassword(event) {
    const specialCharCheck = /[ `!@#$%^&*]/;
    const capitalCheck = /[A-Z]+/;
    const lengthCheck = event.length > 7 && event.length < 31;
    const oneNumber = /.*[0-9].*/;
    const lowerCaseCheck = /[a-z]+/;

    this.blnHasCapital = capitalCheck.test(event);
    this.blnHasLength = lengthCheck;
    this.blnHasOneNumber = oneNumber.test(event);
    this.blnHasSpecialChar = specialCharCheck.test(event);
    this.blnLowerCase = lowerCaseCheck.test(event);
  }

  onAdminResetPassword(form) {
    const finalPayload = {
      Username: this.userCurrent,
      Password: form.value.adminPassword,
      PasswordConfirmation: form.value.adminConfirmPassword,
    };

    this.sharedStateSvc.adminUpdatePwd(finalPayload).subscribe(
      (response: any) => {
        if (response && response.Status === "SUCCESS") {
          alert("Password Reset Successfully");
        } else {
          alert("error in Resetting the password. Please try again.");
        }
        this.resetPassword = false;
        form.form.get("adminConfirmPassword").reset();
        form.form.get("adminPassword").reset();
      },
      (error: any) => {
        alert("error in Resetting the password. Please try again.");
      }
    );
  }

  ngOnDestroy(): void {
    window.localStorage.removeItem("username");
    if (this.eventSub) {
      this.eventSub.unsubscribe();
    }
  }

  showSidenav: boolean = false;

  openSideNav() {
    this.showSidenav = true;
  }

  closeSideNav() {
    this.showSidenav = false;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.screenWidth = window.innerWidth;
  }
}
